import { Locker, Module, PickupBox, Reservation } from './types';

export const cleanLocalStorage = (): void => {
  localStorage.removeItem('pharmacies');
};

export const reformatPickupBox = (initialPickupBox: PickupBox): PickupBox => {
  // The physical (stored) modules array is always kept ordered by `position`
  // (array index === module position). The webtool renders them ordered by
  // `id` instead, but the source of truth stays position-ordered.
  initialPickupBox.info.modules.sort(
    (a: Module, b: Module) => (a.position ?? 0) - (b.position ?? 0)
  );

  initialPickupBox.info.modules.forEach((module: Module) => {
    module.lockers.forEach((locker: Locker) => {
      locker.status = 'free';
    });
  });

  const modules: Module[] = initialPickupBox.info.modules.map(
    (module: Module, index: number) => ({
      ...module,
      id: module.id ?? index
    })
  );

  if (initialPickupBox) {
    Object.keys(modules).forEach((moduleIndex) => {
      const lockers: Locker[] = modules[+moduleIndex].lockers;

      Object.keys(lockers).forEach((lockerIndex) => {
        const lockerId: Locker = lockers[+lockerIndex];

        if (
          (!lockerId.inactive && lockerId.status === 'reserved') ||
          lockerId.status === 'expired'
        ) {
          lockerId.status;
        } else if (lockerId.inactive) {
          lockerId.status = 'inactive';
        }
      });
    });
  }

  if (initialPickupBox.reservations) {
    const reservations: readonly Reservation[] = initialPickupBox.reservations;

    Object.keys(initialPickupBox.reservations).forEach((reservationId) => {
      // eslint-disable-next-line
      const reservationLockerId: any = reservations[+reservationId];
      const lockersWithReservation: string[] =
        reservationLockerId.lockerId || '';

      if (lockersWithReservation) {
        const lockers = lockersWithReservation.filter(
          (id: string) => id.length !== 0
        );
        lockers.forEach((lockerId: string) => {
          // lockerId is `${modulePosition}-${lockerPosition}`, where module
          // position is the physical label shown on top of the module (the
          // module `id` only controls the column where it is rendered).
          const modulePosition = parseInt(lockerId.split('-')[0]);
          const lockerPosition = parseInt(lockerId.split('-')[1]);

          let status = 'free';
          const currentTime = Math.round(new Date().getTime() / 1000);
          if (reservationLockerId) {
            reservationLockerId.reservedTime > currentTime
              ? (status = 'reserved')
              : (status = 'expired');
          }

          const foundModuleIndex: number = modules.findIndex(
            (mod: Module) => mod.position === modulePosition
          );

          if (foundModuleIndex !== -1) {
            const lockerIndex = modules[foundModuleIndex].lockers.findIndex(
              (locker: Locker) => locker.position === lockerPosition
            );

            if (lockerIndex !== -1) {
              modules[foundModuleIndex].lockers[lockerIndex] = {
                ...modules[foundModuleIndex].lockers[lockerIndex],
                status,
                order: reservationLockerId
              };
            }
          }
        });
      }
    });
  }

  return initialPickupBox;
};
